export enum AlgoliaRefinement  {
    BallotStatus = 1,
    BallotType = 2,
    CommitteeCode = 3,
    CommitteeStatus = 4,
    CommitteeSector = 5,
    CommitteeType = 6,
    EntityType = 7,
    ProjectPhase = 8,
    ProjectStatus = 9,
    ProjectType = 10,
    PublicationStatus = 11,
    PublicationType = 12,
}